import { FC } from "react"
import { Stack, Typography } from "@mui/material"
import { TextFieldElement } from "react-hook-form-mui"
import { RtkHookForm } from "@/core/components"
import { GuestBot } from "../../interfaces"
import { useUpdateProfileMutation } from "../../store"

interface IProps {
  bot: GuestBot.Bot
  onDone?: () => void
}
interface FormData {
  name: string
  description: string
  shortDescription: string
}

/**
 * Редактирование текстового профиля живого бота (имя/описания).
 * Значения применяются к боту в Telegram и сохраняются в БД.
 * Пустая строка очищает значение в Telegram.
 */
export const UpdateGuestBotProfileForm: FC<IProps> = ({ bot, onDone }) => (
  <RtkHookForm<FormData, GuestBot.UpdateProfileRes>
    mutationHook={useUpdateProfileMutation as never}
    formContextParams={{
      defaultValues: {
        name: bot.name ?? "",
        description: bot.description ?? "",
        shortDescription: bot.shortDescription ?? "",
      },
    }}
    getSubmitHandlerParams={(data) => ({
      pathParams: { id: bot.id },
      body: {
        name: data.name,
        description: data.description,
        shortDescription: data.shortDescription,
      },
    })}
    afterSubmit={() => onDone?.()}
    successMessage="Профиль бота обновлён"
    actions={[
      {
        text: "Сохранить профиль",
        type: "submit",
        variant: "contained",
        fullWidth: true,
      },
    ]}
  >
    <Stack spacing={2}>
      <Typography variant="subtitle1">Текстовый профиль</Typography>
      <TextFieldElement
        name="name"
        label="Имя бота"
        fullWidth
        helperText="До 64 символов. Пустое значение очистит имя в Telegram."
        validation={{
          maxLength: { value: 64, message: "Максимум 64 символа" },
        }}
      />
      <TextFieldElement
        name="shortDescription"
        label="Короткое описание («о боте»)"
        fullWidth
        multiline
        minRows={2}
        helperText="До 120 символов."
        validation={{
          maxLength: { value: 120, message: "Максимум 120 символов" },
        }}
      />
      <TextFieldElement
        name="description"
        label="Описание (текст в пустом чате)"
        fullWidth
        multiline
        minRows={3}
        helperText="До 512 символов."
        validation={{
          maxLength: { value: 512, message: "Максимум 512 символов" },
        }}
      />
    </Stack>
  </RtkHookForm>
)
